import React from 'react';
import { Card } from '@mui/material';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import { PANEL_HOME_PAGE_TEXT } from '../lang';
import { FundingPanel } from '../../Nomination/components';

type PanelCardProps = {
  title: string;
  startDate: string;
  panelType: FundingPanel;
  endDate: string;
  handleCardClick: () => void;
};

const panelCardDisciplineText: Record<FundingPanel, string> = {
  [FundingPanel.HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES]: 'Humanities',
  [FundingPanel.SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY]: 'Science',
  [FundingPanel.MIXED]: 'Mixed',
};

export const PanelCard: React.FunctionComponent<PanelCardProps> = (
  props: PanelCardProps,
) => {
  const { title, panelType, endDate, handleCardClick } = props;
  const panelInfoList = [
    {
      label: PANEL_HOME_PAGE_TEXT.DISCIPLINE,
      value: panelCardDisciplineText[panelType],
    },
    {
      label: PANEL_HOME_PAGE_TEXT.PANEL_MEETING_TIME,
      value: endDate,
    },
  ];
  return (
    <Card
      onClick={handleCardClick}
      sx={{
        width: 300,
        minHeight: 180,
        padding: '1rem 1.5rem',
        backgroundColor: '#951D1D',
        cursor: 'pointer',
        boxShadow: '2px 3px 8px 1px rgba(0, 0, 0, 0.25)',
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: '18px',
      }}
    >
      <div className="flex flex-row w-full space-between">
        <div className="flex flex-col w-full">
          <div className="font-medium">{PANEL_HOME_PAGE_TEXT.PANEL_NAME}</div>
          <div>{title}</div>
        </div>
        <div>
          <AdsClickIcon
            sx={{
              color: '#ffffff',
              fontSize: '1.5rem',
            }}
          />
        </div>
      </div>
      <div className="flex flex-col w-full">
        {panelInfoList.map((info, index) => (
          <div key={index} className="flex flex-row gap-2">
            <div className="font-medium">{info.label}</div>
            <div>{info.value}</div>
          </div>
        ))}
      </div>
    </Card>
  );
};
